import {IUser} from "../store/user/types";

let remergeCondition: (authUser: any) => boolean = (authUser: any): boolean => authUser && authUser.email && authUser.email.endsWith('@remerge.io')

let remergeAdminCondition: (authUser: IUser) => boolean = (authUser: IUser): boolean => {
    return remergeCondition(authUser) && !!authUser.roles && (!!authUser.roles.ADMIN || !!authUser.roles.SUPER_ADMIN)
}

let remergeSuperAdminCondition: (authUser: IUser) => boolean = (authUser: IUser): boolean => {
    return remergeCondition(authUser) && !!authUser.roles && !!authUser.roles.SUPER_ADMIN
}

export default remergeCondition
export {remergeAdminCondition, remergeSuperAdminCondition}